class ViewSDKClient {
    constructor() {
        this.readyPromise = new Promise((resolve) => {
            if (window.AdobeDC) {
                resolve();
            } else {
                document.addEventListener("adobe_dc_view_sdk.ready", () => {
                    resolve();
                });
            }
        });
        this.adobeDCView = undefined;
    }
    ready() {
        return this.readyPromise;
    }
    previewFile(divId, viewerConfig, url) {
        const config = {
            clientId: process.env.REACT_APP_ADOBE_API_KEY, ///enter Client id here
        };
        if (divId) {
            config.divId = divId;
        }
        this.adobeDCView = new window.AdobeDC.View(config);
        const previewFilePromise = this.adobeDCView.previewFile(
            {
                content: {
                    location: {
                        // url: "https://documentcloud.adobe.com/view-sdk-demo/PDFs/Bodea%20Brochure.pdf"
                        url: url
                    },
                },
                metaData: {
                    fileName: "document.pdf",
                    hasReadOnlyAccess: true
                },
            },
            viewerConfig
        );
        return previewFilePromise;
    }
    async previewFileUsingFilePromise(divId, viewerConfig, fileName, validationDocumentPdf) {
        const myBuffer = Buffer.from(validationDocumentPdf, 'base64');
        this.adobeDCView = new window.AdobeDC.View({
            clientId: process.env.REACT_APP_ADOBE_API_KEY, ///enter Client id here
            divId,
        });
        var filePromises = Promise.resolve(myBuffer);

        this.adobeDCView.previewFile(
            {
                content: {
                    promise: filePromises,
                },
                metaData: {
                    fileName: fileName,
                    hasReadOnlyAccess: true
                },
            },
            viewerConfig,
        );
    }
    registerSaveApiHandler() {
        const saveApiHandler = (metaData, content, options) => {
            console.log(metaData, content, options);
            return new Promise((resolve) => {
                setTimeout(() => {
                    const response = {
                        code: window.AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                        data: {
                            metaData: Object.assign(metaData, {
                                updatedAt: new Date().getTime(),
                            }),
                        },
                    };
                    resolve(response);
                }, 2000);
            });
        };
        this.adobeDCView.registerCallback(
            window.AdobeDC.View.Enum.CallbackType.SAVE_API,
            saveApiHandler,
            {}
        );
    }
    registerEventsHandler() {
        this.adobeDCView.registerCallback(
            window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
            (event) => {
                console.log(event);
            },
            {
                enablePDFAnalytics: true,
            }
        );
    }

    listenForFileUpload(divId, inputId) {
        const config = {
            clientId: process.env.REACT_APP_ADOBE_API_KEY, ///enter Client id here
        };
        if (divId) {
            config.divId = divId;
        }
        var fileToRead = document.getElementById(inputId);
        var adobeDCView = new window.AdobeDC.View(config);

        if (fileToRead) {
            fileToRead.addEventListener("change", function (event) {
                var files = fileToRead.files;
                if (files.length > 0) {
                    var reader = new FileReader();
                    reader.onloadend = function (e) {
                        var filePromise = Promise.resolve(e.target.result);
                        // Pass the filePromise and name of the file to the previewFile API
                        console.log(filePromise)
                        adobeDCView.previewFile({
                            content: {
                                location: {
                                    url: "https://documentcloud.adobe.com/view-sdk-demo/PDFs/Bodea%20Brochure.pdf"
                                },
                            },
                            // content: { promise: filePromise },
                            metaData: {
                                fileName: files[0].name,
                                hasReadOnlyAccess: true
                            }
                        })
                    };
                    reader.readAsArrayBuffer(files[0]);
                }
                this.adobeDCView = undefined;
            }, false);
        }

    }
    /* Helper function to return file content length */
    getInfo(fileSize) {
        return new Promise((resolve, _reject) => {
            resolve({
                fileSize,
            });
        })
    }
    /* Helper function to return the intial array buffer required to render the first page of the linearized PDF */
    getInitialBuffer(fileBuffer) {
        return new Promise((resolve, _reject) => {
            // Simulating initial buffer response
            resolve({
                buffer: fileBuffer.slice(0, 1024) // Passing the first 0-1024 bytes of PDF buffer
            });
        });
    }

    /* Helper function to get the required array buffers of the linearized PDF */
    getPDFBufferRanges(fileBuffer, ranges) {
        var fileSize;
        return new Promise((resolve, _reject) => {
            // Simulating partial content buffer ranges response
            const result = [];
            ranges.forEach(range => {
                result.push(fileBuffer.slice(range.start, range.end + 1));
            });
            resolve({
                bufferList: result
            });
        });
    }
}
export default ViewSDKClient;
